import { render, staticRenderFns } from "./TaxCodeDetails.vue?vue&type=template&id=e9352a32&scoped=true"
import script from "./TaxCodeDetails.vue?vue&type=script&lang=js"
export * from "./TaxCodeDetails.vue?vue&type=script&lang=js"
import style0 from "./TaxCodeDetails.vue?vue&type=style&index=0&id=e9352a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9352a32",
  null
  
)

export default component.exports